import type { Drupal_Node } from 'generated/drupal-graphql';
import type { Lucid } from 'types/types';

export const getEntityFields = (node: Drupal_Node) => {
  const { entityMetatags, entitySchemaMetatags, entityTranslations } = node;

  const combinedTranslations = entityTranslations || [];

  return {
    entityMetatags,
    entitySchemaMetatags,
    // we have to cast this to Drupal_Node to include the extra fields
    // that are added in the query based on Drupal_Node values
    entityTranslations: combinedTranslations as Lucid.Drupal.ExtendedDrupalNode[],
  };
};
